/* Saint Ferro — Mikro-Details. Gesteuert ueber data-Attribute, die sf-head setzt.
   Kein Custom-Cursor: der Systemcursor bleibt ueberall unangetastet. */
(function () {
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Der Schluessel: das Passwortfeld als Schloss ----------
     Reine Anzeige. Das Shopify-Formular (#login_form, name="password") bleibt
     unangetastet - die Kammern spiegeln nur, wie viele Zeichen drinstehen.
     Die Kammern haengen ans ENDE von .password-field, damit Dawns
     "input + label"-Selektor fuer das schwebende Label heil bleibt.
     Laeuft auch bei reduced motion, nur ohne Zucken und Blitz. */
  if (root.dataset.sfKey === '1') {
    var input = document.getElementById('Password');
    var field = input && input.closest('.password-field');
    if (input && field) {
      var MIN = 5, MAX = 12;
      var key = document.createElement('div');
      key.className = 'sf-key';
      key.setAttribute('aria-hidden', 'true');

      var cells = function (n) {
        while (key.children.length < n && key.children.length < MAX) {
          var c = document.createElement('span');
          c.className = 'sf-key-c';
          key.appendChild(c);
        }
        while (key.children.length > Math.max(n, MIN)) key.removeChild(key.lastChild);
      };
      var paint = function () {
        var n = input.value.length;
        cells(Math.max(MIN, n));
        for (var i = 0; i < key.children.length; i++) {
          key.children[i].dataset.on = i < n ? '1' : '0';
        }
        field.dataset.sfN = n;
      };

      cells(MIN);
      paint();
      field.appendChild(key);
      field.classList.add('sf-key-host');
      if (field.classList.contains('password-field--error')) field.classList.add('sf-key-wrong');

      input.addEventListener('input', function () {
        field.classList.remove('sf-key-wrong');
        paint();
      });
      input.addEventListener('focus', paint);

      if (input.form) {
        input.form.addEventListener('submit', function () {
          field.classList.add('sf-key-turn');
          if (reduced) return;
          var fl = document.createElement('div');
          fl.className = 'sf-key-flash';
          fl.setAttribute('aria-hidden', 'true');
          document.body.appendChild(fl);
          setTimeout(function () { if (fl.parentNode) fl.parentNode.removeChild(fl); }, 400);
        });
      }
    }
  }

  /* ---------- Seitenband: SAINT · FERRO senkrecht am linken Rand ----------
     Ab 900 px Breite (CSS). Bewegt sich ueber --sf-scroll, das der
     Scroll-Handler unten setzt. Bei reduced motion steht es still. */
  if (root.dataset.sfLetters === '1') {
    var band = document.createElement('div');
    band.className = 'sf-band';
    band.setAttribute('aria-hidden', 'true');
    var s = '';
    for (var b = 0; b < 6; b++) s += 'SAINT · FERRO · ';
    band.textContent = s;
    document.body.appendChild(band);
  }

  if (reduced) return;

  /* ---------- Der Hammerschlag ----------
     ABGESCHALTET am 06.09.2026 (sf_fx_hammer = false in sf-head). Leon hat ihn
     in vier Anlaeufen nie wahrgenommen - ersetzt durch den hoerbaren Schlag in
     sf-sound.js. Der Code bleibt - der Schalter in sf-head entscheidet. */
  if (root.dataset.sfHammer === '1') {
    var flash = document.createElement('div');
    flash.className = 'sf-hammer';
    flash.setAttribute('aria-hidden', 'true');
    var shock = document.createElement('div');
    shock.className = 'sf-shock';
    shock.setAttribute('aria-hidden', 'true');
    document.body.appendChild(flash);
    document.body.appendChild(shock);

    var starten = function () {
      root.dataset.sfHammerRun = '1';
      setTimeout(function () { root.dataset.sfHammerRun = '0'; }, 1100);
    };
    if (document.readyState === 'complete') setTimeout(starten, 350);
    else window.addEventListener('load', function () { setTimeout(starten, 350); });
  }

  /* ---------- Rueckenprint-Reveal: nur wenn es ein zweites Produktbild gibt ---------- */
  if (root.dataset.sfReveal === '1') {
    if (!document.querySelector('.card__media .media img:nth-child(2)')) {
      root.dataset.sfReveal = '0';
    }
  }

  /* ---------- Scroll: Auskuehlen und Seitenband, ein gedrosselter Handler ---------- */
  var wantCool = root.dataset.sfCool === '1';
  var wantBand = root.dataset.sfLetters === '1';
  if (wantCool || wantBand) {
    var EMBER = [200, 160, 75];
    var IRON  = [120, 132, 148];
    var queued = false;

    var apply = function () {
      queued = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      if (wantCool) {
        var r = Math.round(EMBER[0] + (IRON[0] - EMBER[0]) * p);
        var g = Math.round(EMBER[1] + (IRON[1] - EMBER[1]) * p);
        var bl = Math.round(EMBER[2] + (IRON[2] - EMBER[2]) * p);
        root.style.setProperty('--sf-grade', r + ',' + g + ',' + bl);
        root.style.setProperty('--sf-heat', (1 - p).toFixed(3));
      }
      if (wantBand) root.style.setProperty('--sf-scroll', p.toFixed(4));
    };

    var onScroll = function () {
      if (queued) return;
      queued = true;
      setTimeout(apply, 60);
    };

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }
})();